import React, {useEffect} from 'react';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {gapi} from 'gapi-script';
import './login.css';
import SSOLogin from './SSOLogin';
import {ssoGoogleLogin} from "../../../service/Login/action";

const LoginSso = ({history, ssoGoogleLogin}) => {

    // const clientId = '1088736098243-1249os37p8159hrbq7absbfjok307vfh.apps.googleusercontent.com'; // stage
    const clientId = "562755967467-0pkf2ivf7ivvkq86nqh6f4ikv150us03.apps.googleusercontent.com";

    useEffect(() => {
        if(gapi.client !== undefined){
            const initClient = () => {
                gapi.client.init({
                    clientId: clientId,
                    scope: ''
                });
            };
            gapi.load('client:auth2', initClient);
        }
    }, []);

    return (
        <GoogleOAuthProvider
            // clientId = '1088736098243-1249os37p8159hrbq7absbfjok307vfh.apps.googleusercontent.com'; // stage
            clientId="562755967467-0pkf2ivf7ivvkq86nqh6f4ikv150us03.apps.googleusercontent.com">
            <SSOLogin
                history={history}
                ssoLogin={ssoGoogleLogin}
            ></SSOLogin>
        </GoogleOAuthProvider>
    );
};
export default LoginSso;